export class Filter {
  static DASHBOARD = 'dashboard';
  static NEW_DASHBOARD = 'new_dashboard';
  static SALES = 'sales';
  static MARKETING = 'marketing';
  static LEADS = 'leads';
  static ARCHIVED = 'archived';
  static ONTRACK = 'funnel_ontrack';
  static TOTAL_LEADS = 'total_leads';
  static CONTACTEDS = 'contacteds';
  static TOTAL_VISITS = 'total_visits';
  static VISITEDS = 'visiteds';
  static CLOSEDS = 'closeds';
  static ASSIGNMENT_RULES = 'assignment_rules';
}
